module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/resized/truora-cloudflare-d8266e6c3edc674bef82c93c87917f01.svg";